module.exports = __webpack_public_path__ + "media/images/front/equipment/device_search_ico-94ddeee9571fb5b3770158c1770388ce.svg";